import s from '#components/controls/buttons/buttonPlayRounded/buttonPlayRounded.module.scss';
import useTranslation from 'next-translate/useTranslation';

type Props = {
  href?: string;
};

const ButtonPlayRounded = ({ href }: Props) => {
  const { t } = useTranslation();

  if (href) {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <a href="" className={s.host}>
        <span className={s.inner}>{t('playButton')}</span>
      </a>
    );
  }

  return (
    <span className={s.host} data-block="buttonPlay">
      <span className={s.inner}>{t('playButton')}</span>
    </span>
  );
};

export default ButtonPlayRounded;
